var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentwritingIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L20.7945205,0 C21.89909,-2.16501571e-15 22.7945205,0.8954305 22.7945205,2 L22.7945205,28.9315068 L22.7945205,28.9315068 L2,28.9315068 C0.8954305,28.9315068 1.3527075e-16,28.0360763 0,26.9315068 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-471.000000, -6101.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-22",
    transform: "translate(471.000000, 6101.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    rx: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9",
    transform: "translate(7.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u77E9\\u5F62",
    fill: "#00D097",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6575342,8.28253425 C17.209819,8.28253425 17.6575342,8.7302495 17.6575342,9.28253425 C17.6575342,9.79537009 17.2714941,10.2180414 16.7741554,10.2758065 L16.6575342,10.2825342 L6.53253425,10.2825342 C5.9802495,10.2825342 5.53253425,9.834819 5.53253425,9.28253425 C5.53253425,8.76969841 5.91857444,8.34702709 6.41591312,8.28926198 L6.53253425,8.28253425 L16.6575342,8.28253425 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5950342,14.8578767 C12.147319,14.8578767 12.5950342,15.305592 12.5950342,15.8578767 C12.5950342,16.3707126 12.2089941,16.7933839 11.7116554,16.851149 L11.5950342,16.8578767 L6.53253425,16.8578767 C5.9802495,16.8578767 5.53253425,16.4101615 5.53253425,15.8578767 C5.53253425,15.3450409 5.91857444,14.9223696 6.41591312,14.8646044 L6.53253425,14.8578767 L11.5950342,14.8578767 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#4AD7FF",
    x: 16.8,
    y: 12.2739726,
    width: 15.2,
    height: 16.6575342,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1832192,17.4880137 C28.7355039,17.4880137 29.1832192,17.9357289 29.1832192,18.4880137 C29.1832192,19.0008495 28.797179,19.4235209 28.2998403,19.481286 L28.1832192,19.4880137 L20.5599315,19.4880137 C20.0076468,19.4880137 19.5599315,19.0402984 19.5599315,18.4880137 C19.5599315,17.9751779 19.9459717,17.5525065 20.4433104,17.4947414 L20.5599315,17.4880137 L28.1832192,17.4880137 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0796233,23.1866438 C26.631908,23.1866438 27.0796233,23.6343591 27.0796233,24.1866438 C27.0796233,24.6994797 26.6935831,25.122151 26.1962444,25.1799161 L26.0796233,25.1866438 L20.5599315,25.1866438 C20.0076468,25.1866438 19.5599315,24.7389286 19.5599315,24.1866438 C19.5599315,23.673808 19.9459717,23.2511367 20.4433104,23.1933716 L20.5599315,23.1866438 L26.0796233,23.1866438 Z",
    id: "\\u8DEF\\u5F84-38",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentwritingIconBig);
export default __webpack_public_path__ + "static/media/Intelligentwriting_icon_big.0ca4350f57d83383f9539d77d178309e.svg";
export { ForwardRef as ReactComponent };